import React from "react"
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"
import Note from "components/Note/Note"
import { TextInput } from "components-design-system"

const RJTextInput = ({ id, carbonProps, invalid, value, onChange, onFocus, onBlur }) => {
  const variant = invalid ? "error" : undefined

  if (carbonProps.defaultValue === false) {
    return (
      <>
        <TextInput
          status={variant}
          id={id + "-field"}
          className="rjs-widget"
          disabled={carbonProps?.disabled}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          style={carbonProps?.styles && carbonProps.styles.widget}
          onBlur={onBlur}
        />
      </>
    )
  }

  return (
    <>
      <TextInput
        status={variant}
        id={id + "-field"}
        className="rjs-widget"
        disabled={carbonProps?.disabled}
        defaultValue={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        style={carbonProps?.styles && carbonProps.styles.widget}
        onBlur={onBlur}
      />
    </>
  )
}

export default InputWrapper(RJTextInput)
